export const COMPANY_TABS = [
    { value: "company", label: "EMPRESA" },
    { value: "marketToMarket", label: "MARKET TO MARKET" },
    { value: "balance", label: "BALANÇOS" },
    { value: "emission", label: "EMISSÕES" },
    { value: "economicGroup", label: "GRUPO ECONÔMICO" },
    { value: "otherDocuments", label: "OUTROS DOCUMENTOS" },
]
